import StationDetailContainer from "./StationDetailContainer";
import StationDetailStore from "./StationDetailStore";
export default StationDetailStore(StationDetailContainer);